export type AuthUser = {
  id: number
  displayName: string
  title?: string
  firstName?: string
  surname?: string
  mail: string
  eduPersonPrincipalName: string
  roles: string[]
  organisation: { id: number; name: string; isActive: boolean } | undefined
  mimickedByUser?: {
    id: number
    displayName: string
    mail: string
  }
  userSessionId: number
}

export function bytesToTeraBytes(bytes: number, fractionDigits = 2): string {
  return (bytes / 1e12).toFixed(fractionDigits)
}

export function kbToTb(kb: number, fractionDigits: number): string {
  return (kb / 1e9).toFixed(fractionDigits)
}

export function bytesToGigaBytes(bytes: number, fractionDigits = 2): string {
  return (bytes / 1e9).toFixed(fractionDigits)
}

export function calMedian(arr: number[]): number {
  if (arr.length === 0) return 0
  const sortedArr = [...arr].sort((a, b) => a - b)
  const middle = Math.floor(sortedArr.length / 2)
  if (sortedArr.length % 2 === 0) {
    return (sortedArr[middle - 1] + sortedArr[middle]) / 2
  }
  return sortedArr[middle]
}

export function calAvg(sum: number, count: number): number {
  if (count === 0) return 0
  return sum / count
}

export const nl2br = (value: string) => {
  return (value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2')
}

export const getDatasetPackagingStatusLabel = (status: number) => {
  if (status === 0) return 'Available'
  if (status === 1 || status === 2) return 'Packaging'
  if (status === -1) return 'Error'
  return 'Unknown'
}

export const getDatasetEspaceStatusLabel = (status: number) => {
  if (status === 0) return 'Published'
  if (status === 1 || status === 2) return 'Pending'
  if (status === 8) return 'Removed'
  if (status === -1) return 'Error'
  return 'Unknown'
}

type BareCollaborator = {
  user?: { displayName: string; mail: string }
  invitation?: { name: string; mail: string }
}

export const getCollaboratorName = (collaborator: BareCollaborator) => {
  return collaborator.user ? collaborator.user.displayName : collaborator.invitation?.name || ''
}

export const getCollaboratorMail = (collaborator: BareCollaborator) => {
  return collaborator.user ? collaborator.user.mail : collaborator.invitation?.mail || ''
}

export const isUq = (eduPersonPrincipalName?: string | null) => {
  if (!eduPersonPrincipalName) return false
  return eduPersonPrincipalName.endsWith('@uq.edu.au')
}

export const isStudent = (eduPersonPrincipalName?: string | null) => {
  if (!eduPersonPrincipalName) return false
  if (isUq(eduPersonPrincipalName)) {
    const username = eduPersonPrincipalName.substring(0, eduPersonPrincipalName.indexOf('@'))
    return /^[s][0-9]{7}$/.test(username)
  }
  return false
}
